<div class="search-page">
  <div class="container" style="max-width: 1440px;">
    <app-breadcrumb *ngIf="currentCategoryName" [data]="[{
      name: currentCategoryName,
      link: '/category/' + currentCategorySlug,
      active: true
    }]"></app-breadcrumb>

    <div class="rounded header-wrapper w-100 d-flex justify-content-center align-items-center flex-column"
      style="width: fit-content; position: relative;">

      <div class="back-button-section">
        <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i>
          Back</button>
      </div>
      <div class="position-relative d-flex flex-column align-items-center justify-content-end">
        <img lass="d-none" (load)="topImageLoad($event)" *ngIf='currentCategoryBG' [src]='imgUrl + currentCategoryBG'
          style="background-repeat: no-repeat;" class="rounded" />
        <div class="title postion-relative" style="width: fit-content;" [class.cat-name]="currentCategoryBG">
          {{ currentCategoryName }}
        </div>
      </div>

      <div class="header">

        <!-- <div [innerHTML]="subCategory?.codeSchema">
        </div> -->
        <script type="application/ld+json" *ngIf="subCategory?.codeSchema">
          {{subCategory?.codeSchema}}
        </script>
      </div>
      <router-outlet></router-outlet>

      <!-- Sub category -->
      <section class="row mx-1 mt-4" *ngIf="subCategoryList && subCategoryList.length > 0">
        <div class="col-2 sub-category" [routerLink]="'/category/' + i.slug" *ngFor="let i of subCategoryList">
          {{ i?.categoryName }}
        </div>
      </section>
      <!-- Sub category -->

      <div class="hidden-mobile h-100 w-100">


        <div class="grid-wrapper">
          
          <div>
            <app-product-types-list  [showAllTypes]="true" [editable]="false"  *ngIf="isInitDone" 
            [categoryId]="subCategory?.id" [class.d-none]="(!typesExist || !isInitDone ) && !isUserAnAdmin"
            (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()"></app-product-types-list>
         
          </div>
        

          <!-- Product List -->
          <div class="d-flex flex-column" *ngIf="totalMemberShopProductList?.length">
            <div class="products mb-2 w-100">
              <common-product-card-view (view)="viewProductDetails($event)" [isSelected]="i < 5" [canBeSelected]="true" (selected)="productSelectedChanged(list, $event)"
                *ngFor="let list of totalMemberShopProductList; let i = index" [list]="list" [isCommunityProduct]="true"
                [toSinglePage]="true"></common-product-card-view>


            </div>
            <div class="show-more" (click)="getProductList()">
              <div *ngIf="currentPage < lastPage">Show more <i class="fa-solid fa-chevron-down"></i></div>
            </div>
          </div>

          <ng-container *ngIf="totalMemberShopProductList?.length == 0 && !isLoading">
            <div
              style="display: flex; justify-content: center; flex-direction: column; align-items: center; height: 200px; font-size: 1.5rem; border: dotted 3px #59288040">
              <p><i class="fa fa-exclamation-circle" aria-hidden="true"></i> No Item found</p>
            </div>
          </ng-container>
          <div class="d-flex flex-column">
            <button   class="btn m-1  mb-2 search-btn" *ngIf="productsToCompare?.length" (click)="openCompareProductsModal()"><i class="fa-solid fa-code-compare"></i>  Compare Products</button>
            <app-product-faq-list [categoryId]="subCategory?.id" 
            (faqsExist)="faqsExist = $event"></app-product-faq-list>
        
          </div>
         
        </div>

      </div>
      <div class="hidden-desktop h-100 w-100">

        <app-my-carousel-swiper class="product-mobile-swiper" [config]="carOptions">
          <div class="swiper-slide" *ngIf="typesExist || !isInitDone">
            <app-product-types-list [showAllTypes]="true" [editable]="false"
              *ngIf="isInitDone" [categoryId]="subCategory?.id" (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()"></app-product-types-list>
          </div>

          <div class="swiper-slide">

            <div class="d-flex flex-column justify-content-center">
              <div class="products mb-2 w-100">
                <common-product-card-view (view)="viewProductDetails($event)" [isSelected]="i < 5" [canBeSelected]="true" (selected)="productSelectedChanged(list, $event)"
                  *ngFor="let list of totalMemberShopProductList; let i = index" [list]="list"
                  [isCommunityProduct]="true" [toSinglePage]="true"></common-product-card-view>


              </div>
              <div class="show-more" (click)="getProductList()">
                <div *ngIf="currentPage < lastPage">Show more <i class="fa-solid fa-chevron-down"></i></div>
              </div>
            </div>

            <ng-container *ngIf="totalMemberShopProductList?.length == 0">
              <div
                style="display: flex; justify-content: center; flex-direction: column; align-items: center; height: 200px; font-size: 1.5rem; border: dotted 3px #59288040">
                <p><i class="fa fa-exclamation-circle" aria-hidden="true"></i> No Item found</p>
              </div>
            </ng-container>

          </div>
          <div class="swiper-slide">
            <div class="d-flex flex-column">
              <button   class="btn m-1  mb-2 search-btn" *ngIf="productsToCompare?.length" (click)="openCompareProductsModal()"><i class="fa-solid fa-code-compare"></i>  Compare Products</button>
              <app-product-faq-list [categoryId]="subCategory?.id" 
              (faqsExist)="faqsExist = $event"></app-product-faq-list>
           
            </div>
          </div>

        </app-my-carousel-swiper>


      </div>
      <div>
        <button class="btn btn-secondary w-100 mb-2 d-block d-md-none mt-3" (click)="showMap = !showMap">
          <i [ngClass]="showMap ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
          {{ showMap ? "Hide Map" : "Show Map" }}
        </button>
      </div>
      <div class="mt-2 map" [class.d-none]="totalMemberShopProductList?.length == 0 || !showMap" id="map"></div>


      <ng-container *ngIf="subCategory.relationCategories?.length > 0">
        <div class="w-100 d-flex justify-content-center align-items-center flex-column">
          <div class="header my-2 ">
            <div class="title">Other Categories</div>
          </div>

          <div class="d-flex mt-2" style="flex-wrap: wrap;">
            <span class="mr-2 mt-2" *ngFor="let sub of subCategory.relationCategories">
              <button class="my-button-3" [routerLink]="'/category/' + sub.slug">
                {{ sub.name }}
              </button>
            </span>
          </div>


        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="bottomText && bottomText != 'undefiend' && bottomText != 'null' ">
      <div class="mt-2 m-4" style="text-align: center;" [innerHTML]="bottomText">

      </div>
    </ng-container>

  </div>
  <app-marketplace #marketplace [share]="true"></app-marketplace>